<div class="overlap-dialog">
  <mat-dialog-content>
    <!-- Header -->
    <div class="dialog-header">
      <mat-icon class="overlap-icon">sync_problem</mat-icon>
      <h2 mat-dialog-title>Page Overlap Detected</h2>
    </div>

    <!-- Overlap Information -->
    <div class="overlap-info">
      <p class="overlap-description">The following pages have already been ingested:</p>

      <app-file-page-scope
        mode="card"
        [source]="scopeSource"
        [fileDisplay]="data.filename"
        [pageDisplay]="overlappingPagesText"
      />
    </div>

    <!-- Resolution Options -->
    <div class="resolution-options">
      <p class="options-title">How would you like to handle these existing pages?</p>

      <mat-radio-group [(ngModel)]="selectedAction" class="radio-group">
        <!-- Skip Option -->
        <mat-radio-button value="skip" class="radio-option">
          <div class="option-content">
            <div class="option-header">
              <span class="option-title">Skip existing pages (process only new pages)</span>
            </div>
            <div class="option-benefits">
              <div class="benefit">
                <mat-icon class="benefit-icon success">check_circle</mat-icon>
                <span>Faster processing (only {{ getNewPagesCount() }} new pages)</span>
              </div>
              <div class="benefit">
                <mat-icon class="benefit-icon success">check_circle</mat-icon>
                <span>Preserves existing analysis</span>
              </div>
            </div>
          </div>
        </mat-radio-button>

        <!-- Force Reprocess Option -->
        <mat-radio-button value="force-reprocess" class="radio-option">
          <div class="option-content">
            <div class="option-header">
              <span class="option-title">Force reprocess all pages</span>
            </div>
            <div class="option-benefits">
              <div class="benefit">
                <mat-icon class="benefit-icon warning">warning</mat-icon>
                <span>Overwrites existing content</span>
              </div>
              <div class="benefit">
                <mat-icon class="benefit-icon warning">warning</mat-icon>
                <span>Takes longer to complete ({{ getTotalPagesCount() }} total pages)</span>
              </div>
            </div>
          </div>
        </mat-radio-button>
      </mat-radio-group>
    </div>
  </mat-dialog-content>

  <!-- Actions -->
  <mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()">Cancel</button>
    <button mat-raised-button color="primary" (click)="onContinue()">
      <mat-icon>play_arrow</mat-icon>
      Continue
    </button>
  </mat-dialog-actions>
</div>
